;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('inputEmoji', inputEmoji)

  /* @ngInject */
  function inputEmoji () {
    return {
      restrict: 'EA',
      scope: {
        label: '@',
        model: '=',
        disabled: '<',
        mandatory: '<',
        change: '<'
      },
      templateUrl: '/core/directives/input-emoji/input-emoji-directive.html?$$REVISION$$',
      controller: 'InputEmojiController'
    }
  }
})()
